module.exports = __webpack_public_path__ + "img/grid_layout_3_2.abc58b2d.svg";